import guid from "@ciaopeople/cp-shatsu/Utils";
import { GenericQSStatsCollector } from "./GenericQSStatsCollector.js";
import { MediaId } from "../../../model/MediaInfo.js";
import { MapperConfigFlags } from "../mappers/CommonEventMapper.js";
import { CP_EmbedType } from "../../ads/adcall/CustomParams.js";
import { CPProductName } from "../../../config/CPProducts.js";



interface CData {
    
    id: string, // collector-id
    v: string, // player version
    src: "web", //source context
    l: string, //label
    ts: number, // timestamp
    vid: MediaId,
    eu: string, //embed url
    rf?: string, //referral

}

export interface YMStatsMapperConfig extends MapperConfigFlags {
    embedType: CP_EmbedType,
    product: CPProductName,
    ymHostname: string,
    playerName: string
};



export class YMStatsCollector extends GenericQSStatsCollector{

    private collectorId: string;
    constructor(private window: Window, baseUrl: string) {
        super("YMStats",baseUrl);
        this.collectorId = guid();
    }




    public collectEvent(videoId: MediaId, label: string,  playerVersion: string = "parthenope"): Promise<void> {
        
        
        if(videoId && videoId != "" && label && label != "") {          
            const data: CData = {
                id: this.collectorId,
                v: playerVersion,
                src: "web",
                l: label,
                ts: new Date().getTime(),
                vid: videoId,
                eu: this.window.location.href.toString(),
            };
            if(document.referrer) data.rf = document.referrer.toString();
            return this.collect("GET", data);
        }
        else return Promise.reject("Missing label and/or videoid");

    }
 

}